import {
  atom,
  selector,
} from 'recoil';
import moment from 'moment';

const userState = atom({
  key: 'userState',
});

const orderStartedState = selector({
  key: 'orderStartedState',
  get: ({ get }) => {
    const user = get(userState);
    if (!user) {
      return undefined;
    }
    const { orders: userOrders = [] } = user;
    // The server sorts orders by market start date.
    // This finds the first Started order in that sorted list.
    const orderStarted = userOrders.find((o) => o.order_state === 'Started');
    if (orderStarted) {
      const orderWindowClose = orderStarted.market_event?.order_window_close;
      if (orderWindowClose) {
        if (moment(orderWindowClose).isBefore(moment())) {
          return undefined;
        }
      } else {
        return undefined;
      }
    }
    return orderStarted;
  },
});

export {
  orderStartedState,
  userState,
};
